import { render, staticRenderFns } from "./all_fj.vue?vue&type=template&id=2f7e9248&scoped=true"
import script from "./all_fj.vue?vue&type=script&lang=js"
export * from "./all_fj.vue?vue&type=script&lang=js"
import style0 from "./all_fj.vue?vue&type=style&index=0&id=2f7e9248&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e9248",
  null
  
)

export default component.exports